<template>
  <div>
    <table class="table is-fullwidth is-size-7">
      <tr>
        <th>#</th>
        <th colspan="7">{{"bk bets.bet" | translate}}</th>
        <th>{{"bk bets.profit" | translate}}</th>
      </tr>
      <template v-for="(bet, i) in bets">
        <tr :class="{'bk-bets-even':i%2==0}">
          <td>{{bet.id}}</td>
          <td colspan="2" class="has-text-weight-bold">
            <router-link v-if="showUser" :to="{ name: 'player', params: { playerId: bet.userId } }">{{bet.username}}</router-link>
            {{bet.created | datetime}}
            <span v-if="bet.bkType == 'single'">{{"bk bets.type.single" | translate}}</span>
            <span v-if="bet.bkType == 'express'">{{"bk bets.type.express" | translate}} {{bet.bkSelections.length}}</span>
            <span v-if="bet.bkType == 'system'">{{"bk bets.type.system" | translate}} {{bet.bkSystemN}}/{{bet.bkSelections.length}}</span>
          </td>
          <td colspan="3">{{"bk bets.bet" | translate}} <span class="has-text-weight-bold">{{ bet.amount | currency(bet.currency) }}</span></td>
          <td>@{{bet.bkSelections.reduce((res, s) => res*s.factor, 1) | rate}}</td>
          <td>
            <span v-if="bet.bkIsDeleted" class="has-text-grey has-text-weight-bold">{{"bk bets.deleted" | translate}}</span>
            <span v-if="!bet.bkIsDeleted">
              <span v-if="bet.bkStatus=='win'" class="has-text-danger has-text-weight-bold">{{bet.bkStatus.toUpperCase()}} {{ bet.win | currency(bet.currency) }}</span>
              <span v-if="bet.bkStatus=='loss'" class="has-text-link has-text-weight-bold">{{bet.bkStatus.toUpperCase()}} {{ bet.amount | currency(bet.currency) }}</span>
            </span>
          </td>
          <td>
            <span v-if="!bet.bkIsDeleted"  class="has-text-weight-bold" :class="{'has-text-danger':!bet.bkIsDeleted && bet.win > bet.amount, 'has-text-success':!bet.bkIsDeleted && bet.win < bet.amount}">{{ bet.amount - bet.win | currency(bet.currency) }}</span>
          </td>
        </tr>
        <tr v-for="selection in bet.bkSelections" :class="{'bk-bets-even':i%2==0}">
          <td></td>
          <td>{{ selection.sport }}</td>
          <td>{{ selection.league }}</td>
          <td>{{ selection.eventStartAt | datetime }} <span class="has-text-weight-semibold">{{ selection.event }}</span></td>
          <td>{{ selection.class }}</td>
          <td>{{ selection.type }}</td>
          <td>@{{ selection.factor | rate }}</td>
          <td>
            <span v-if="bet.bkIsDeleted">{{"bk bets.deleted" | translate}}</span>
            <span v-if="!bet.bkIsDeleted" :class="{'has-text-danger': selection.status=='win', 'has-text-link': selection.status=='loss'}">{{ selection.status }}</span>
          </td>
          <td></td>
        </tr>
      </template>
    </table>

    <pagination @change="loadBets();" ref="pagination" :page-size="10" />
  </div>
</template>

<script>
  import pagination from './pagination.vue'

  export default {
    name: 'bk-bets-list',
    components: { pagination },
    props: {
      dataFunc: {
        type: Function,
        required: true
      },
      showUser: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        bets: []
      }
    },
    async mounted() {
      await this.loadBets();
    },
    methods: {
      async loadBets() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize
        };
        const data = await this.dataFunc(filter);
        this.bets = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/bk-bets-list.vue